import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ScreenType } from 'src/app/enums/ScreenType';
import { UserRegDetails } from 'src/app/models/user';
import { Visitor } from 'src/app/models/visitor';

@Component({
  selector: 'app-exisiting-visitor-dialog',
  templateUrl: './exisiting-visitor-dialog.component.html',
  styleUrls: ['./exisiting-visitor-dialog.component.scss'],
})
export class ExisitingVisitorDialogComponent {
  hostFilter = new FormControl();
  filteredHosts: UserRegDetails[] = [];
  hostName: string = null;
  visitorData: Visitor;
  todatDate = new Date();
  currentYear = new Date().getFullYear();
  minDate = new Date(
    this.currentYear + 0,
    this.todatDate.getMonth(),
    this.todatDate.getDate()
  );
  maxDate = new Date(this.currentYear + 0, new Date().getMonth() + 6, 0);

  @Output() onSendInvitation = new EventEmitter();
  screenSize: ScreenType;
  ScreenType = ScreenType;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formbuilder: FormBuilder
  ) {
    this.screenSize = data.screen;
    this.existingVisitorForm.controls.purpose.setValue(data.visitors.purpose);
    this.existingVisitorForm.controls.visitorId.setValue(
      data.visitors.visitorID
    );
    this.existingVisitorForm.controls.FirstName.setValue(
      data.visitors.firstName
    );
    this.existingVisitorForm.controls.LastName.setValue(data.visitors.lastName);
    this.existingVisitorForm.controls.IsActive.setValue(data.visitors.isActive);
    this.existingVisitorForm.controls.VisitorAddress.setValue(
      data.visitors.visitorAddress
    );
    this.existingVisitorForm.controls.CarRegistration.setValue(
      data.visitors.carRegistration
    );
    this.existingVisitorForm.controls.SecurityStatus.setValue(
      data.visitors.securityStatus
    );
    this.filteredHosts = data.users;
    this.visitorData = data.visitors;
    this.hostFilter.valueChanges.subscribe((value) => {
      this.filteredHosts = this.filterHosts(value);
    });
  }
  existingVisitorForm = this.formbuilder.group({
    visitorId: [''],
    hostEmail: [''],
    hostName: [''],
    FirstName: [''],
    LastName: [''],
    VisitorAddress: [''],
    SecurityStatus: [''],
    CarRegistration: [''],
    IsActive: [''],
    hostUserId: ['', Validators.required],
    purpose: ['', Validators.required],
    newEPassValidity: ['', Validators.required],
  });
  filterHosts(value: string) {
    const filterValue = value.toLowerCase();
    return this.data.users.filter((host: any) =>
      `${host.firstname} ${host.lastname}`.toLowerCase().includes(filterValue)
    );
  }
  hostSelect(val: MatAutocompleteSelectedEvent) {
    this.data.users.forEach((item: any) => {
      if (item.firstname + ' ' + item.lastname === val.option.value) {
        this.hostName = item.firstname + ' ' + item.lastname;
        this.existingVisitorForm.controls.hostEmail.setValue(item.email);
        this.existingVisitorForm.controls.hostUserId.setValue(item.userId);
      }
    });
    this.existingVisitorForm.controls.hostName.setValue(this.hostName);
  }
}
